// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import './ContactSupportModal.css';

interface ContactSupportModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactSupportModal: React.FC<ContactSupportModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const contacts = [
    { name: 'AI Foundry Team', email: 'theshelf@accellor.com' },
    { name: 'Khaled Al-Basti', email: 'khaled.basti@accellor.com' },
    { name: 'Hesham Mabrouk', email: 'hesham.mabrouk@accellor.com' },
    { name: 'Akshay Goel', email: 'akshay.goel@accellor.com' }
  ];

  return (
    <div className="support-overlay" onClick={handleOverlayClick}>
      <div className="support-modal">
        <div className="support-header">
          <h2 className="support-title">Contact Support</h2>
          <button className="support-closeButton" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="support-content">
          <p className="support-intro">Please contact below for any queries:</p>

          <div className="support-contacts">
            {contacts.map((contact, index) => (
              <div key={index} className="support-contactItem">
                <div className="support-contactName">{contact.name}</div>
                <a href={`mailto:${contact.email}`} className="support-contactEmail">
                  {contact.email}
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="support-footer">
          <button className="support-closeButtonBottom" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactSupportModal;
